<template>
  <section
    id="intro"
    class="text-center mb-12"
  >
    <div style="padding: 40px; text-align: center; background-color: #f4f4f4">
      <h1 style="color: #333; font-size: 2rem; margin-bottom: 20px">
        Welcome to our video podcasts!
      </h1>
      <p
        style="
          font-size: 1.2rem;
          color: #666;
          max-width: 900px;
          margin: 0 auto;
          margin-bottom: 30px;
        "
      >
        Discover our growing set of video podcasts designed to give you good
        ideas and entertain you.
      </p>
    </div>

    <podcast-video
      title="Fifth episode: New Modulation System in Annaliis."
      video-id="8ZXECE0tvyM"
      :accepted-analytics-cookies="acceptedAnalyticsCookies"
      :accepted-marketing-cookies="acceptedMarketingCookies"
      :accepted-preferences-cookies="acceptedPreferencesCookies"
    />

    <podcast-video
      title="Fourth episode: MES Arpeggiator."
      video-id="Vvp_bCsC6Ro"
      :accepted-analytics-cookies="acceptedAnalyticsCookies"
      :accepted-marketing-cookies="acceptedMarketingCookies"
      :accepted-preferences-cookies="acceptedPreferencesCookies"
    />

    <podcast-video
      title="Third episode: Making a beat in FL Studio."
      video-id="hVDdHobr_gE"
      :accepted-analytics-cookies="acceptedAnalyticsCookies"
      :accepted-marketing-cookies="acceptedMarketingCookies"
      :accepted-preferences-cookies="acceptedPreferencesCookies"
    />

    <podcast-video
      title="Second episode: Introducing the patch breeding and averaging."
      video-id="zFw6Z8eBUYc"
      :accepted-analytics-cookies="acceptedAnalyticsCookies"
      :accepted-marketing-cookies="acceptedMarketingCookies"
      :accepted-preferences-cookies="acceptedPreferencesCookies"
    />

    <podcast-video
      title="Welcome to our first episode and our first guest Eoin Rossney!"
      video-id="rMiQ1I9sq1Y"
      :accepted-analytics-cookies="acceptedAnalyticsCookies"
      :accepted-marketing-cookies="acceptedMarketingCookies"
      :accepted-preferences-cookies="acceptedPreferencesCookies"
    />

    <br />
    <div class="cta-buttons">
      <button
        style="width: 320px; height: 44px; text-transform: none"
        class="cta-button download-button"
        @click="handleButtonClick('Buy')"
      >
        Buy Annaliis
      </button>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Headline',
    components: {
      PodcastVideo: () => import('@/vue_files/components/PodcastVideo')
    },
    data () {
      return {
        acceptedAnalyticsCookies: false,
        acceptedFunctionalCookies: false,
        acceptedMarketingCookies: false,
        acceptedPreferencesCookies: false,
      }
    },

    computed: {
      videoUrl () {
        // Create a function that returns the URL based on an index
        return (index) => {
          return 'https://www.youtube.com/embed/' + this.videos[index]
        }
      },
    },

    created () {
      // Perform the initial check as soon as the component is created.
      this.checkCookieConsent()
    },
    mounted () {
      // Set up a repeating check every 2 seconds after the component is mounted.
      this.checkInterval = setInterval(this.checkCookieConsent, 2000)
    },

    methods: {
      checkCookieConsent () {
        if (window.cookiehub) {
          this.acceptedAnalyticsCookies =
            window.cookiehub.hasConsented('analytics')
          this.acceptedFunctionalCookies =
            window.cookiehub.hasConsented('functional')
          this.acceptedMarketingCookies =
            window.cookiehub.hasConsented('marketing')
          this.acceptedPreferencesCookies =
            window.cookiehub.hasConsented('preferences')
        }
      },

      handleButtonClick (buttonType) {
        this.$router.push({ name: 'Buy' })
      },
      isUserLoggedIn () {
        return this.$store.getters.isUserLoggedIn
      },
      userPurchased () {
        return this.$store.getters.purchased
      },
    },
  }
</script>

<style scoped>
.headline {
  /* Presuming this is your existing style for '3 Unique User Interfaces' */
  font-size: 2.5rem; /* Example size, adjust as necessary */
  font-weight: light;
  margin-bottom: 8px;
}

.section-headline {
  /* New style for the individual UI sections, slightly smaller */
  font-size: 2.2rem; /* Slightly smaller than the main headline */
  font-weight: light;
  margin-bottom: 8px;
}

.middle-third {
  width: 45%; /* 100 / 3 to get one-third */
  margin: 0 auto; /* Center the div */
}

@media (max-width: 960px) {
  .middle-third {
    width: 100%; /* On smaller screens, take full width */
  }
}

/* If you have other content in .info-section that shouldn't be centered,
   you'll need to wrap the list in another div that will be flexed */
.list-container {
  display: flex;
  justify-content: center; /* Centers the child horizontally */
  width: 100%; /* Takes up 100% of the info-section */
}

.info-section li {
  text-align: left; /* Ensuring list items are also aligned to the left if needed */
  line-height: 1.5; /* Improved readability for list items */
}

@media (max-width: 600px) {
  .image-width {
    width: 100%; /* Full width on smaller screens */
  }
}

.cta-buttons {
  display: flex;
  justify-content: center; /* Centering the buttons */
  padding: 20px;
  gap: 20px; /* Adds space between buttons */
}

.cta-button {
  padding: 10px 40px; /* Increased horizontal padding */
  border: none;
  border-radius: 5px;
  font-size: 18px; /* Slightly larger font size */
  cursor: pointer;
  transition: background-color 0.3s;
  width: 320px;
  min-width: 320px; /* Minimum width */
  background-color: #4caf50; /* Green */
  color: white;
}

.cta-button:hover {
  opacity: 0.9;
}

.ui-sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ui-block {
  background-color: #f0f0f0;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.heading {
  font-size: 1.5em;
  color: #333;
}

.content-wrapper {
  max-width: 1200px; /* Max width to align with the image */
  margin: 0 auto; /* Centering the wrapper */
}

.image-width {
  width: 80%; /* This controls the image size relative to its container */
  display: block; /* Ensures the image behaves as a block element, centering with margin auto */
  margin: 0 auto; /* Center the image horizontally */
}

/* Button styles */
button {
  margin: 10px;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
}
</style>
